import { render } from "./sideBanner.vue?vue&type=template&id=b5504482&scoped=true"
const script = {}

import "./sideBanner.vue?vue&type=style&index=0&id=b5504482&lang=scss&scoped=true"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5504482"]])

export default __exports__